import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useConfig() {
  const { data } = useQuery({
    queryKey: ["config"],
    queryFn: async () => (await api.get("/config")).data,
    staleTime: 60_000,
  });
  return data;
}
